import React, { useEffect } from 'react';
import './SharedVisibilityReportPage.scss';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import { useGetSharedVisibilityReport } from '../../shared/api/hooks/visibility-report/useGetSharedVisibilityReport';
import Loader from '../../shared/components/common/loader/Loader';
import { useDownloadVisibilityReportPdf } from '../../shared/api/hooks/visibility-report/useDownloadVisibilityReportPdf';
import VisibilityReportSlides from './components/VisibilityReportSlides';
import useToast from '../../shared/hooks/global/UseToast';

/** Raport otwierany z udostępnionego linku — bez logowania, bez panelu, bez nawigacji do aplikacji. */
const SharedVisibilityReportPage: React.FC = () => {
  const { t } = useTranslation();
  const { token = '' } = useParams();
  const { data: report, isLoading, isError } = useGetSharedVisibilityReport(token);
  // Strona z linku nie ma nagłówka aplikacji, więc przycisk PDF zostaje na okładce raportu.
  const { download, isDownloading } = useDownloadVisibilityReportPdf(report, token);
  const { showToast, toastElement } = useToast();
  const downloadPdf = () =>
    download().catch(() => showToast(t('visibilityReport.errorGeneric'), 'error'));

  // Globalny `body { overflow: hidden }` z index.scss — bez tego raportu nie da się przewinąć.
  useEffect(() => {
    document.body.classList.add('visible');
    return () => document.body.classList.remove('visible');
  }, []);

  if (isLoading) {
    return (
      <div className="shared-report-page">
        <div className="shared-report shared-report--message">
          <Loader />
        </div>
      </div>
    );
  }

  if (isError || !report) {
    return (
      <div className="shared-report-page">
        <div className="shared-report shared-report--message">
          <h1>{t('visibilityReport.sharedUnavailableTitle')}</h1>
          <p>{t('visibilityReport.sharedUnavailableDesc')}</p>
        </div>
      </div>
    );
  }

  return (
    <div className="shared-report-page">
      {toastElement}
      <div className="shared-report">
        <VisibilityReportSlides
          report={report}
          onDownloadPdf={downloadPdf}
          isDownloading={isDownloading}
        />
      </div>
    </div>
  );
};

export default SharedVisibilityReportPage;
